import { Icon } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { paths } from '@mc/paths'
import CTA from 'components/CTA'
import { checkoutCtaTrackProps } from '../../utils/events'
import { ITEMS } from './constants'

export const SubscriptionExperience = () => {
  const { t } = useTranslation('@mc/next')
  const items = ITEMS

  return (
    <div className='mc-my-10 container'>
      <div className='row'>
        <div className='col-12 col-md-6 col-xl-5'>
          <h2 className='mc-text-h2 mc-text--center mc-text-md--left'>
            {t('guestPassRecipient.valueProps.title')}
          </h2>

          <div className='d-none d-md-block'>
            <CTA
              href={paths.checkout}
              className='mc-mt-4'
              trackProps={checkoutCtaTrackProps}
            >
              {t('guestPass.claim.cta')}
            </CTA>
          </div>
        </div>

        <div className='col-12 col-md-6 col-xl-7'>
          <ul className='list-unstyled row mc-p-4'>
            {items.map(({ kind, text }, index) => (
              <li className='list-item col-12 col-lg-6 d-flex' key={index}>
                <Icon
                  className='mc-icon--3 mc-opacity--hinted mc-mr-3'
                  kind={kind}
                />
                <p>{text}</p>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className='d-block d-md-none'>
        <CTA
          href={paths.checkout}
          className='mc-mt-4'
          fullWidth
          trackProps={checkoutCtaTrackProps}
        >
          {t('guestPass.claim.cta')}
        </CTA>
      </div>
    </div>
  )
}
